import {
  TEntityResponse,
  TEntityListResponse,
  TConfigTypeResBody,
  TConfigTypeSummaryResBody,
} from '@poseidon-city/shared';

import { TAPIClient } from '../client';

type TConfigsClient = {
  get(id: string): Promise<TEntityResponse<'config-type', TConfigTypeResBody> | undefined>;
  list(limit: number, page: number): Promise<TEntityListResponse<'config-type', TConfigTypeSummaryResBody> | undefined>;
};

function ConfigsClient(apiClient: TAPIClient): TConfigsClient {
  return {
    async get(id: string): Promise<TEntityResponse<'config-type', TConfigTypeResBody> | undefined> {
      const data = await apiClient.get<TEntityResponse<'config-type', TConfigTypeResBody>>(`/config-types/${id}`);

      if (data && data.type !== 'config-type') {
        throw new Error('Invalid entity type received, expected: config-type, received: ' + data.type);
      }

      return data;
    },
    async list(
      limit: number,
      page: number
    ): Promise<TEntityListResponse<'config-type', TConfigTypeSummaryResBody> | undefined> {
      const data = await apiClient.get<TEntityListResponse<'config-type', TConfigTypeSummaryResBody>>(
        `/config-types?limit=${limit}&page=${page}`
      );

      if (data && data.type !== 'config-type') {
        throw new Error('Invalid entity type received, expected: config-type, received: ' + data.type);
      }

      return data;
    },
  };
}

export { TConfigsClient, ConfigsClient };
